exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".statusesContainer {\n  margin-top: 20px;\n  height: calc(100vh - 120px);\n  overflow: auto;\n  padding: 0 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/CustomerOrderStatuses/CustomerOrderStatuses.scss
// module id = 1717
// module chunks = 0